import { render, staticRenderFns } from "./RelatorioOrcamentoResultados.vue?vue&type=template&id=64371a8c&"
import script from "./RelatorioOrcamentoResultados.vue?vue&type=script&lang=js&"
export * from "./RelatorioOrcamentoResultados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports